import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import store from './store';
import './i18n';   // App 보다 먼저 — 첫 렌더에 번역이 준비돼 있어야 한다
import App from './App';
import './index.css';
import { resetAllStores } from './store/resetStore';

import '@xyflow/react/dist/style.css';
import { fixResizeObserverErrors } from './utils/ResizeObserverErrorFix';
import { applyTheme, getInitialTheme } from './utils/theme';

// 첫 렌더 전에 <html class="dark"> 를 확정해 라이트→다크 깜빡임을 막는다
applyTheme(getInitialTheme());

// 앱 시작 시 Redux 상태 초기화
resetAllStores();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// 앱 시작 전 패치 적용
fixResizeObserverErrors();

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
); 